import angular from 'angular';

class modalContainerEnableCtrl {
  /*@ngInject*/
  constructor($uibModal, logger, ContainerService) {
    this.$uibModal = $uibModal;
    this.logger = logger;
    this.ContainerService = ContainerService;
  }

  $onInit() {
    this.containersSelected = angular.copy(this.resolve.containersSelected);
    this.ContainerService.checkEnable(this.containersSelected).$promise.then(
      result => {
        this.disableConfirm = false;
        this.containersCanBeEnable = result;
      },
      () => {
        this.logger.error('principal.containers.error_check_enable');
      }
    );
  }

  cancel() {
    this.modalInstance.dismiss('cancel');
  }

  ok() {
    this.disableConfirm = true;
    this.ContainerService.enable({
      containersIds: this.containersCanBeEnable,
      createRemoteFolders: false
    }).$promise.then(
      pathNotExists => {
        if (pathNotExists && pathNotExists.length > 0) {
          this.$uibModal
            .open({
              component: 'modalContainerEnableConfirm',
              resolve: {
                pathNotExists: () => {
                  return pathNotExists;
                }
              },
              backdrop: 'static',
              keyboard: false
            })
            .result.then(
              () => this.closeContainerEnableConfirmModal(),
              () => this.dismissModal()
            );
        } else {
          this.logger.success('Les containers ont été activés');
          this.modalInstance.close();
        }
      },
      error => {
        this.disableConfirm = false;
        if (error.data && error.data.message) {
          this.logger.error(error.data.message, null, 'principal.containers.error_enable', null, 100000);
        } else {
          this.logger.error('principal.containers.error_enable');
        }
      }
    );
  }

  closeContainerEnableConfirmModal() {
    this.ContainerService.enable({
      containersIds: this.containersCanBeEnable,
      createRemoteFolders: true
    }).$promise.then(
      () => {
        this.logger.success('Les containers ont été activés');
        this.disableConfirm = false;
        this.modalInstance.close();
      },
      () => {
        this.disableConfirm = false;
        this.logger.error('principal.containers.error_enable');
      }
    );
  }

  dismissModal() {
    this.disableConfirm = false;
  }
}

angular.module('app.principal').component('modalContainerEnable', {
  templateUrl: require('./modal-container-enable.html'),
  controller: modalContainerEnableCtrl,
  bindings: {
    modalInstance: '<',
    resolve: '<'
  }
});
